var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"CompWallet"},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.url,"frameborder":"0","border":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }